<template>
  <el-select
    v-model="name"
    clearable
    :disabled="disabled? true : false"
    :filter-method="filterTree"
    filterable
    placeholder="请选择"
    @clear="handleClear"
  >
    <el-option class="select-tree scroller" :style="maxHeight?'max-height:'+maxHeight+'px':''" :value="treeList">
      <el-tree
        ref="treeRef"
        check-on-click-node
        :current-node-key="singleChoice?currentShowKey:''"
        :data="treeList"
        :default-checked-keys="!singleChoice?currentShowKey:[]"
        default-expand-all
        highlight-current
        :node-key="nodeKey"
        :props="defaultProps"
        @node-click="handleCheck"
      >
        <template #default="{ node }">
          <el-tooltip
            class="box-item"
            :content="node.data[defaultProps.label]"
            effect="dark"
            placement="right"
          >
            <div class="el-tree-show">
              <div class="el-tree-show-name" style="flex: 1">
                <div style="margin-right:4px; ">
                  <div v-if="!node.data.hasOwnProperty('type_id')" style="display: flex; align-items: center;">
                    <svg v-if="node.expanded && node.data.panos?.length" t="1731591802108" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="79043" width="16" height="16"><path d="M321.28 128a64 64 0 0 1 49.92 24l35.2 43.968a32 32 0 0 0 24.96 12.032H896a64 64 0 0 1 64 64V352H260.032a64 64 0 0 0-61.312 45.824L64 852.48V192a64 64 0 0 1 56.512-63.552L128 128h193.28z" fill="#42B5EB" p-id="79044"></path><path d="M979.84 473.088l-109.056 368a32 32 0 0 1-30.72 22.912H186.88a32 32 0 0 1-30.72-41.088l109.056-368a32 32 0 0 1 30.72-22.912H949.12a32 32 0 0 1 30.72 41.088z" fill="#77D3FB" p-id="79045"></path><path d="M175.36 758.912a32 32 0 0 0 30.72 41.088h653.248a32 32 0 0 0 28.8-18.048l1.024-2.816-18.368 61.952a32 32 0 0 1-30.72 22.912H186.88a32 32 0 0 1-30.72-41.088l19.2-64z" fill="#000000" fill-opacity=".1" p-id="79046"></path></svg>
                    <svg v-else t="1731591737982" class="icon" width="16" height="16"  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="78756"><path d="M321.28 128H128a64 64 0 0 0-64 64v448h896V272a64 64 0 0 0-64-64H431.36a32 32 0 0 1-24.96-12.032l-35.2-43.968A64 64 0 0 0 321.28 128z" fill="#42B5EB" p-id="78757"></path><path d="M128 288h768a64 64 0 0 1 64 64V832a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V352a64 64 0 0 1 64-64z" fill="#77D3FB" p-id="78758"></path><path d="M64 768a64 64 0 0 0 56.512 63.552L128 832h768a64 64 0 0 0 63.552-56.512L960 768v64a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64v-64z" fill="#000000" fill-opacity=".1" p-id="78759"></path></svg>
                  </div>
                  <i v-else class="iconfont iconquanjing"></i>
                </div>
                <span style="max-width: 75%; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ node.data[defaultProps.label] }}  </span><span v-if="node.data.hasOwnProperty('panos')">({{ node.data.pano_num}})</span>
              </div>
            </div>
          </el-tooltip>
        </template>
      </el-tree>
    </el-option>
  </el-select>
</template>
<script>
import { reactive, ref, toRefs, onMounted, defineComponent, watch } from 'vue'
import { Tree,Tooltip } from 'element-ui'
export default defineComponent({
  name: '',
  components: { 'el-tree':Tree ,'el-tooltip':Tooltip},
  props: {
    /* 组件的使用
    <select-tree
      v-if="treeDataList && treeDataList.length"
      :tree-data-list="treeDataList"
      :singleC-choice="false"
      :current-choose-key="list"
      @select-list="selectList"
    ></select-tree>
    import selectTree from "@/views/components/selectTree";
    */
    treeDataList: {
      type: Array,
      default () {
        return []
      }
    },
    currentChooseKey: {
      type: Array,
      default () {
        return []
      }
    },
    singleChoice: {
      type: Boolean,
      default: true
    },
    defaultProps: {
      type: Object,
      default () {
        return {
          children: 'panos',
          label: 'name',
          disabled: 'disabled'
        }
      }
    },
    maxHeight: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    nodeKey: {
      type: String,
      default: 'id'
    }
  },
  setup (props, context) {
    const state = reactive({
      treeRef: null,
      treeList: [],
      copyTreeList: [],
      currentShowKey: 0,
      name: '',
      id: ''
    })
    const { emit } = context
    watch(
      () => props.treeDataList,
      (newVal) => {
        console.log(newVal, 'watch监听')
        state.treeList = JSON.parse(JSON.stringify(newVal))
        state.copyTreeList = JSON.parse(JSON.stringify(newVal))
        if (props.singleChoice) {
          state.currentShowKey = JSON.parse(JSON.stringify(props.currentChooseKey))[0]
          const loop = (tree, id) => {
            tree.forEach(element => {
              if (element[props.nodeKey] === id) {
                state.name = element.name
              } else if (element[props.defaultProps.children] && element[props.defaultProps.children].length) {
                loop(element[props.defaultProps.children], id)
              }
            })
          }
          loop(newVal, props.currentChooseKey[0])
        } else {
          state.currentShowKey = JSON.parse(JSON.stringify(props.currentChooseKey))
          const loop = (tree, showList) => {
            tree.forEach(element => {
              showList.forEach(item => {
                if (element[props.nodeKey] === item) {
                  if (!state.name) {
                    state.name = element.name
                  } else {
                    if (state.name.split(',').indexOf(element.name) === -1) {
                      state.name += ',' + element.name
                    }
                  }
                } else if (element[props.defaultProps.children] && element[props.defaultProps.children].length) {
                  loop(element[props.defaultProps.children], showList)
                }
              })
            })
          }
          loop(newVal, props.currentChooseKey)
        }
      },
      {
        immediate: true,
        deep: true
      }
    )
    onMounted(() => {})
    const filterTree = (val) => {
      const mapTree = (value, arr) => {
        const newarr = []
        arr.forEach(element => {
          if (element.name.indexOf(value) > -1) { // 判断条件
            newarr.push(element)
          } else {
            if (element.children && element.children.length > 0) {
              const redata = mapTree(value, element.children)
              if (redata && redata.length > 0) {
                const obj = {
                  ...element,
                  children: redata
                }
                newarr.push(obj)
              }
            }
          }
        })
        return newarr
      }
      if (val) {
        state.treeList = mapTree(val, state.treeList)
      } else {
        state.treeList = state.copyTreeList
      }
      state.name = val
    }
    const handleCheck = (node) => {
      // eslint-disable-next-line no-prototype-builtins
      if (!props.singleChoice || !node.hasOwnProperty('pano_name')) {
        return
      }
      state.name = node.name
      state.currentShowKey = node[props.nodeKey]
      emit('select-list', node)
    }
    // 清空
    const handleClear = (val) => {
      if (!val || val === '') {
        if (props.singleChoice) {
          state.currentShowKey = null
        } else {
          state.currentShowKey = []
          const treeRef = ref(state.treeRef)
          treeRef.value.setCheckedKeys([], false)
        }
        state.treeList = state.copyTreeList
      }
    }
    /* 当前选择的nodekey数组 */
    const handleCheckChange = (data) => {
      // eslint-disable-next-line no-prototype-builtins
      if (props.singleChoice || !data.hasOwnProperty('pano_name')) {
        return
      }
      console.log('勾选触发')
      const treeRef = ref(state.treeRef)
      const keys = treeRef.value.getCheckedKeys()
      const arr = keys.filter((item) => item > 0)
      state.currentShowKey = arr
      emit('select-list', state.currentShowKey)
      state.name = ''
      listLoop(state.copyTreeList, state.currentShowKey)
    }
    const listLoop = (tree, showList) => {
      const loop = (arr, list) => {
        arr.forEach(element => {
          list.forEach(item => {
            if (element[props.nodeKey] === item) {
              if (!state.name) {
                state.name = element.name
              } else {
                state.name += ',' + element.name
              }
            }
          })
          if (element[props.defaultProps.children] && element[props.defaultProps.children].length) {
            loop(element[props.defaultProps.children], list)
          }
        })
      }
      loop(tree, showList)
    }
    return {
      ...toRefs(state),
      handleCheck,
      filterTree,
      handleClear,
      handleCheckChange,
      listLoop
    }
  }
})
</script>
<style lang='less' scoped>
.select-tree {
  height: auto;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  padding: 0;
  :deep(.el-tree){
    .el-tree-show {
        width: 100%;
        margin: 10px 0;
        display: flex;
        padding-left: 5px;
        padding-right: 8px;
        justify-content: space-between;
        overflow: hidden;
        .el-tree-show-name {
          display: flex;
          align-items: center;
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 14px;
          color: #606266;
          .tree-icon {
            z-index: 1;
            padding-right: 4px;
            line-height: 26px;
            img {
              height: 14px;
              width: 14px;
              margin-top: 6px;
            }
          }
        }
        .el-tree-show-edit {
          width: auto;
          color: #000;
          i {
            font-size: 14px;
          }
          &.hover {
            visibility: hidden;
          }
        }
      }
  }
}
</style>
